<template>
  <div class="dialogBox " >
    <el-dialog class="preview"   :visible.sync="showDialog" @close="clkCloseBtn" :close-on-click-modal="false" custom-class="borRad10" width="800px">
      <div>
        <img :src="imgSrc" alt="" style="width:800px">
      </div>
      <div style="text-align:center;padding:10px 0" >
        <a class="blueBtn30" @click="clkCloseBtn">BACK</a>
    </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgSrc:'',
      showDialog:false
    }
  },
  created() {
 
  },
  methods:{
    clkDialog(){
      this.showImg()
      this.showDialog=true
    },
    showImg() {
      if(this.$route.path === '/exp/expDetails') {
        this.imgSrc = '../../../../static/img/previewExp2.jpg'
      } 
      if(this.$route.path === '/air/airDetails') {
        this.imgSrc = '../../../../static/img/previewAir2.jpg'
      }
    },
    //关闭弹窗
    clkCloseBtn(){
      this.showDialog=false
    },
  }
}
</script>
<style  scoped>
.blueBtn30{display: inline-block; width: 80px;font-size: 12px; height: 26px;line-height: 26px;text-align: center;    border: 1px solid #004FB1;border-radius: 30px;background-color: #004FB1;color: #fff !important;}
</style>

 


// WEBPACK FOOTER //
// src/components/userCenter/public/preview.vue